import React from "react";
import styles from "../styles/styles";

export default function TrainModePanel({
    items = [],
    atcSpeed = 0

}) {

    const topItems = items.slice(0, 3);
    const bottomItem = items[3];
    const PURPLE_ITEMS = [
        "Cabine ativa",
        "ATC ativo"
    ];

    const getActiveColor = (label) =>
        PURPLE_ITEMS.includes(label)
            ? "#967ADD"
            : "#ef4444";
    return (
        <div style={styles.trainModeContainer}>

            <div style={styles.trainHVACSidebar}>

                {/* LABELS */}
                <div style={styles.trainHVACSidebarLabels}>

                    {topItems.map((item, index) => (

                        <div
                            key={index}
                            style={{
                                ...styles.trainHVACStatusLabel,

                                background:
                                    item.active
                                        ? getActiveColor(item.label)
                                        : styles.trainHVACStatusLabel.background,

                                color:
                                    item.active
                                        ? "#ffffff"
                                        : "#111827"
                            }}
                        >
                            {item.label}
                        </div>

                    ))}

                    {bottomItem && (
                        <div
                            style={{
                                ...styles.trainHVACStatusLabel,

                                background:
                                    bottomItem.active
                                        ? getActiveColor(bottomItem.label)
                                        : styles.trainHVACStatusLabel.background,

                                color:
                                    bottomItem.active
                                        ? "#ffffff"
                                        : "#111827"
                            }}
                        >
                            {bottomItem.label}
                        </div>
                    )}

                </div>

                {/* VALORES */}
                <div style={styles.trainHVACSidebarValues}>

                    <div
                        style={{
                            ...styles.trainHVACATCBox,
                        }}
                    >
                        {atcSpeed ?? "-"}
                    </div>

                    {bottomItem && (
                        <div
                            style={{
                                ...styles.trainHVACStatusValue,

                                background:
                                    bottomItem.valueActive
                                        ? getActiveColor(bottomItem.label)
                                        : styles.trainHVACStatusValue.background,

                                color:
                                    bottomItem.valueActive
                                        ? "#ffffff"
                                        : "#111827"
                            }}
                        >
                            {bottomItem.value}
                        </div>
                    )}

                </div>

            </div>

        </div>
    );
}